let global = {
  search: 'Pesquisar',
  filters: 'Filtros'
}

export default global
